import React from 'react';
import { Modal } from '@insurancemenu/imenu-components-lib';
import { Clock } from '@insurancemenu/imenu-components-lib/dist/icons';
import { createStyles } from './styles';

interface Props {
  show: boolean;
  onClose: () => void;
  attemptNumber: number;
}

const ContinuousRatesPullingModal = ({ show, attemptNumber, onClose }: Props): JSX.Element => {
  const progressDone = +`${attemptNumber + 1}0`;
  // eslint-disable-next-line no-nested-ternary
  const validatedProgressDone = +progressDone > 0 ? (+progressDone <= 100 ? `${progressDone}%` : '100%') : 0;

  const classes = createStyles({ validatedProgressDone, attemptNumber });
  return (
    <Modal show={show} onClose={onClose} className={classes.modal} closable={false}>
      <Clock width="8rem" className={classes.icon} />
      {attemptNumber > -1 ? (
        <>
          <p className={classes.title}>Please wait while we retrieve rates</p>
          <b className={classes.completeStatus}>{`${validatedProgressDone} complete`}</b>
          <div className={classes.progress}>
            <div className={classes.progressDone} />
          </div>
        </>
      ) : (
        <p className={classes.title}>Almost done, we’re updating your catalog</p>
      )}
    </Modal>
  );
};

export default ContinuousRatesPullingModal;
